// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__8gVVE","header":"ClearentDisclaimer_header__3Qqra","inner":"ClearentDisclaimer_inner__2pwe8"};